import { render, staticRenderFns } from "./CloudConsultResetQuotaButton.vue?vue&type=template&id=0a7bc07a&scoped=true"
import script from "./CloudConsultResetQuotaButton.vue?vue&type=script&lang=js"
export * from "./CloudConsultResetQuotaButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7bc07a",
  null
  
)

export default component.exports